import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'; 
import axios from 'axios';
import { useHistory } from 'react-router-dom'; 

function Page4SubPageA3() {
    // store search query input value 
    const [query, setQuery] = useState(''); 

    // array of book search results
    const [books, setBooks] = useState([]); 

    // boolean to indicate whether data is being loaded from backend
    const [loading, setLoading] = useState(false); 

    const history = useHistory(); 

    const [openReviewDialog, setOpenReviewDialog] = useState(false);
    const [review, setReview] = useState('');
    const [selectedBook, setSelectedBook] = useState(null);

    // fxn handles search logic
    const handleSearch = async () => {
        // return if empty input
        if (!query.trim()) return;

        // setLoading is true when search is in progress
        setLoading(true);

        try {
            // send get request to backend
            const res = await axios.get(`/api/books/search?q=${encodeURIComponent(query)}`);
            // update books array with response data from server
            setBooks(res.data);
        } catch(err) {
            console.error('Failed to fetch books:', err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Box p={4}>
            <Typography variant="h4">Search for Books</Typography>

            {/* Search input and button */}
            <Box display="flex" gap={2} mt={2}>
                <TextField
                    label="Book Name"
                    variant="outlined"
                    value={query} // The input field is controlled by `query`
                    onChange={(e) => setQuery(e.target.value)} // Update `query` when user types
                />
                <Button variant="contained" onClick={handleSearch}>
                    Search
                </Button>
            </Box>

            {loading && <Typography>Loading...</Typography>}

            {/* Map over the books array and render each book */}
            {books.map((book) => (
            <Box
                key={book._id} // Each book needs a unique key (MongoDB ID here)
                mt={3}
                p={2}
                border="1px solid #ccc"
                borderRadius="6px"
            >
                {/* Display book title and author */}
                <Typography variant="h6">{book.title}</Typography>
                <Typography variant="body2">{book.author}</Typography>

                {/* Buttons for actions (currently just one to view PDF) */}
                <Box mt={1} display="flex" gap={2}>
                <Button
                    variant="contained"
                    //onClick={() => window.open(`/api/books/pdf/${book._id}`, '_blank')}
                    onClick={() => history.push(`/books/read/${book._id}`)}
                >
                    Read
                </Button>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setSelectedBook(book);
                        setOpenReviewDialog(true);
                    }}
                >
                    Post
                </Button>
                <Dialog open={openReviewDialog} onClose={() => setOpenReviewDialog(false)}>
                    <DialogTitle>Post Review for {selectedBook?.title}</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Write your review"
                            fullWidth
                            multiline
                            rows={4}
                            value={review}
                            onChange={(e) => setReview(e.target.value)}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenReviewDialog(false)}>Cancel</Button>
                        <Button 
                        onClick={async () => {
                            try {
                                await axios.post('/api/bookReview', {
                                    bookId: selectedBook._id,
                                    content: review
                                });
                                alert("Review posted!");
                                setOpenReviewDialog(false);
                                setReview('');
                                } catch (err) {
                                console.error("Failed to post review:", err);
                            }
                        }} 
                        variant="contained"
                        >
                        Post
                        </Button>
                    </DialogActions>
                </Dialog>

                </Box>
            </Box>
            ))}
        </Box>
    );
}

export default Page4SubPageA3;